

function BanerDashboard({ text }) {
    return (
        <div className="flex flex-row-reverse items-center justify-between bg-purpleMedium02 m-2 rounded-lg shadow px-4 py-2">
            <h1 className="t-purpleDark text-lg font-extrabold">{text}</h1>
        </div>
    )
}
export default BanerDashboard;